import React, { useContext } from 'react';
import { Helmet } from 'react-helmet-async';
import { ConfigContext } from 'context/config';

const MetaTags = () => {
  const config = useContext(ConfigContext);
  const TAGS = {
    TMG: {
      title: 'Gym Texting and Email Communication Platform',
      description:
        'Powerful communication platform built exclusively for Gym owners, to save money, slash cancellations, & drive profits.',
      image:
        'https://cdn.sanity.io/images/3hh5dgyf/production/11e56659d1d63c63eb0ac8ece319b84e4e180a1f-600x600.png?w=900&q=80',
    },
    TIC: {
      title: 'Church Texting and Email Communication Software | Text In Church',
      description:
        'Text In Church is the trusted church communication software that provides effective, yet simple, email communication and text messaging for churches. Spend less time managing tools and more time building relationships.',
      image: `${config.REACT_APP_UI_URL}/assets/images/text-in-church-banner.jpg`,
    },
    HITCHED: {
      title: 'Hitched',
      description: 'Hitched',
    },
  };
  const tags = TAGS[config.BRAND];

  return (
    <Helmet>
      <meta name="title" content={tags.title} />
      <meta name="description" content={tags.description} />
      <meta property="og:title" content={tags.title} />
      <meta property="og:description" content={tags.description} />
      <meta property="og:url" content={config.REACT_APP_UI_URL} />
      <meta property="og:image" content={tags.image} />
      <meta name="twitter:card" content={tags.image} />
      {config.BRAND === 'TIC' && (
        <>
          <meta name="twitter:site" content="@textinchurch" />
          <meta name="twitter:creator" content="@textinchurch" />
        </>
      )}
      <meta name="twitter:title" content={tags.title} />
      <meta name="twitter:description" content={tags.description} />
      <meta name="twitter:image" content={tags.image} />
    </Helmet>
  );
};

export default MetaTags;
